import React from 'react'
import DataTag from './DataTag'

import '../App.css'
import '../styles/main.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function LotFinder(props){
    const panelStyle = () => {
        if (props.panel.lot){
            return {
                position: 'absolute',
                zIndex: '1',
                height: '73vh',
                width: '23em',
            }
        }
    }
    const contentStyle = () => {
        if (props.panel.lot){
            return {
                overflowY: 'scroll',
                height: '90%'
            }
        }
    }
    const lotAddress = () => {
        if (props.address === undefined || props.address === null || props.address === ''){
            return "- -"
        }
        else {
            const str = props.address;
            // console.log(str);
            return str;
        }
    }

    return(
        <div className="component" style={panelStyle()}>
            <div className="card-header">
                <div className="header-front">
                    <FontAwesomeIcon icon={['fa', 'vector-square']} size="2x" className="font-awesome-spacing"/>
                    <h2 className="text-header">Lot</h2>
                </div>
                <button id="lot" onClick={props.expandClick} className="expand-icon">
                            {props.panel.lot ? 
                             <FontAwesomeIcon icon={['fa', 'minus']} className="font-awesome-win"/> :
                             <FontAwesomeIcon icon={['far', 'window-maximize']} className="font-awesome-win"/>
                            }
                </button>
            </div>            

            <div className="card-content" style={contentStyle()}>
                <h3 className="text-light">Lot Address</h3>
                <h2 className="text-bold">{lotAddress()}</h2>  
                <DataTag 
                    heading1={"Block Type"}
                    content1={props.blockNumber === undefined ? 'N/A' : props.blockNumber}
                    heading2={"Land Use"}
                    content2={props.landUse === undefined ? 'N/A' : props.landUse}
                />
                <DataTag 
                    heading1={"Lot Type"}
                    content1={props.lotType === undefined ? 'N/A': props.lotType}
                    heading2={"Lot Number"}
                    content2={props.lotNumber === undefined ? 'N/A' : props.lotNumber}
                />
                <h3 className="text-light">Lot Data</h3>
                <table>
                    <thead>
                    <tr>
                        <th>Value</th>
                        <th>Quantity</th>
                    </tr>

                    </thead>
                    <tbody>
                    <tr>
                        <td>Lot Area</td>
                        <td>{props.lotArea} sf</td>
                    </tr>
                    <tr>
                        <td>Lot Front</td>
                        <td>{props.lotFront} ft</td>
                    </tr>            
                    <tr>
                        <td>Lot Depth</td>
                        <td>{props.lotDepth} ft</td>
                    </tr> 
                    </tbody>
                </table>
            </div>

            
        </div>
    )
}
